<div class="admin-wrapper">
  <div class="header">
    <statistics></statistics>
  </div>
  <div class="body">
    <search (filter)="updateSearch($event)"></search>
    <hotels [search]="search"></hotels>
  </div>
  <div class="footer">
    <button (click)="openOnboarding()">Onboarding</button>
    <button (click)="openEmail()">Email</button>
  </div>
</div>
